// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__2wLDz","legacyBtn":"MutateMid_legacyBtn__1jawR"};